/**
 * CrashClaw 默认 Agent 人设（与后端 CrashClawAgentDefaults.DEFAULT_SYSTEM_PROMPT 语义对齐）。
 * 创建工作区时传 null 即可，后端 createAgent 会自动填充。
 */
export const CRASHCLAW_DEFAULT_SYSTEM_PROMPT = `你是 CrashClaw，CrashSight 基于 CodeBuddy 打造的智能体助手，专门帮助游戏与应用研发团队处理崩溃、ANR、异常与稳定性问题，并串联 CrashSight 平台上的分析、分单、修复与监控工作流。

【身份】
- 对外自称 CrashClaw（可称「CrashClaw 缺陷机器人」），不要自称 Hermes Agent 或通用 ChatGPT。
- 你运行在用户专属 Bridge 沙箱中，通过 CrashSight Web 与企业微信等通道服务用户。

【能力原则】
- 优先使用已配置的 MCP 工具（尤其 CrashSight MCP）查询真实数据，再下结论；禁止编造 issue ID、堆栈、统计数据或处理人。
- 工具失败时给出可操作的排障步骤（权限、参数、Bridge/MCP 状态）。

【回答结构】回答必须有逻辑、有条理，按以下顺序组织：
1. 结论：一句话说明当前判断或能直接回答的部分。
2. 依据：列出关键数据、日志片段或推理步骤（分点，避免大段堆砌）。
3. 行动：给出可执行的下一步建议（查什么、改什么、派给谁）。
不确定处明确标注「待验证」或「假设」；默认使用中文，代码与日志保持原文。

【文件发送】当用户需要你产出的文件时，在回复末尾单独一行使用：
SEND_FILE:"/文件/路径/目标文件"
用户即可通过 CrashSight Web 下载。如果发送未生效，可能是旧版 Agent 不支持，请提醒用户更新工作区或重建工作区。

【边界】
- 不泄露 Bridge Token、API Key、MCP 密钥。
- 不假装已执行沙箱外未授权的操作（如直接改线上配置、未授权合并代码）。`;
/** 与后端 CrashClawLlmModels.DEFAULT_MODEL / install.sh DEFAULT_LLM_MODEL 一致 */
export const DEFAULT_LLM_MODEL = 'deepseek-v4-pro';
/**
 * LLM 模型白名单（value 为 Venus 模型 id，须与后端 CrashClawLlmModels.java 保持一致）。
 * 已与 Venus /v1/models 实际可用列表核对（2026-06）。
 */
export const VENUS_LLM_MODELS = [
    // Claude
    { value: 'claude-opus-4-8', label: 'Claude Opus 4.8' },
    { value: 'claude-opus-4-7', label: 'Claude Opus 4.7' },
    { value: 'claude-sonnet-4-6', label: 'Claude Sonnet 4.6' },
    { value: 'claude-4-5-haiku-20251001', label: 'Claude Haiku 4.5' },
    // GPT
    { value: 'gpt-5.5', label: 'GPT-5.5' },
    { value: 'gpt-5.4', label: 'GPT-5.4' },
    { value: 'gpt-4o', label: 'GPT-4o' },
    // DeepSeek
    { value: 'deepseek-v4-pro', label: 'DeepSeek V4 Pro' },
    { value: 'deepseek-v4-flash', label: 'DeepSeek V4 Flash' },
    { value: 'deepseek-v3.2', label: 'DeepSeek V3.2' },
    // GLM
    { value: 'glm-5.1', label: 'GLM-5.1' },
    { value: 'glm-5', label: 'GLM-5' },
    // Kimi
    { value: 'kimi-k2.6', label: 'Kimi K2.6' },
    { value: 'kimi-k2.5', label: 'Kimi K2.5' },
    // Qwen
    { value: 'qwen3.6-35b-a3b', label: 'Qwen3.6 35B' },
    { value: 'qwen3.5-397b-a17b', label: 'Qwen3.5 397B' },
    // Hunyuan
    { value: 'hy3-preview', label: 'Hunyuan 3 (Preview)' },
];
/** 工作区 / 本地知识库 zip 上传上限（与 api-server CrashClawCosPaths.MAX_WIKI_FILE_SIZE、
 *  spring.servlet.multipart.max-file-size=10MB 一致） */
export const MAX_WIKI_FILE_BYTES = 10 * 1024 * 1024;
export const MAX_WIKI_FILE_MB = MAX_WIKI_FILE_BYTES / (1024 * 1024);
/** CrashClaw 工作区详情弹窗的 zIndex，显式声明以保证与嵌套弹窗的层级顺序稳定。 */
export const CRASHCLAW_MODAL_Z_INDEX = 1000;
/** 从工作区详情弹窗内触发的二级弹窗（如 RepoAuthorizeModal）用这个 zIndex，确保始终盖在详情弹窗之上。 */
export const CRASHCLAW_NESTED_MODAL_Z_INDEX = CRASHCLAW_MODAL_Z_INDEX + 1;
